import api from './index'

export const uploadImage = (data) => {
  return api({ url: '/admin/common/uploader/1', method: 'post', data })
}
